import { useEffect, useState } from 'react';
import { api, type Me } from './api.js';
import { Login } from './pages/Login.js';
import { Expeditions } from './pages/Expeditions.js';
import { ExpeditionPage } from './pages/Expedition.js';
import { DayPage } from './pages/Day.js';
import { EventPage } from './pages/Event.js';
import { GapsPage } from './pages/Gaps.js';
import { ReviewPage } from './pages/Review.js';
import { HistoryPage } from './pages/History.js';
import { SettingsPage } from './pages/Settings.js';
import { useRoute } from './router.js';

export function App() {
  const [me, setMe] = useState<Me | null | undefined>(undefined);
  const route = useRoute();
  useEffect(() => { api<{ user: Me }>('GET', '/api/me').then((r) => setMe(r.user), () => setMe(null)); }, []);
  if (me === undefined) return <p className="loading">Loading…</p>;
  if (me === null) return <Login onSignedIn={setMe} />;
  switch (route.name) {
    case 'expedition': return <ExpeditionPage exp={route.exp} />;
    case 'day': return <DayPage exp={route.exp} day={route.day} />;
    case 'event': return <EventPage exp={route.exp} id={route.id} />;
    case 'gaps': return <GapsPage exp={route.exp} />;
    case 'review': return <ReviewPage exp={route.exp} />;
    case 'history': return <HistoryPage exp={route.exp} kind={route.kind} id={route.id} />;
    case 'settings': return <SettingsPage me={me} exp={route.exp} />;
    default: return <Expeditions me={me} />;
  }
}
